import { useTranslation } from "react-i18next";
import InputField from "../../components/shared/InputField";
import MultiSelect from "../../components/shared/MultiSelect";
import NormalButton from "../../components/shared/NormalButton";
import PageHeader from "../../components/shared/PageHeader";
import MainContent from "../../containers/shared/MainContent";
import NormalFormContainer from "../../containers/shared/NormalFormContainer";
import PageMain from "../../containers/shared/PageMain";
import useDocumentTitle from "../../components/helpers/useDocumentTitle";
import { useNavigate } from "react-router-dom";
import { useContext, useEffect, useState } from "react";
import { UserContext } from "../../App";
import apiClient from "../../components/utils/apiClient";


const InventoryAddPage = () => {

    const { InventoryCategoriesOptions } = useContext(UserContext);
    const {t,i18n} = useTranslation();
    useDocumentTitle('إضافة مخزون جديد');
    const navigate = useNavigate();
    const pageTitle = {title: 'إضافة مخزون جديد', subTitle: 'يمكنك إضافة مخزون جديد من هنا.'};
    const EmptyAddInventoryForm = {
        itemName: "",
        itemCode: "",
        category: "",
        storageLocation: "",
        quantity: "",
        issuedQuantity: "",
        reorderPoint : "",
        supplierInfo: ""
    };
    const [addInventoryForm,setAddInventoryForm] = useState(EmptyAddInventoryForm);
    const [errors, setErrors] = useState(null);
    const [isAddInventoryFormDisabled, setIsAddInventoryFormDisabled] = useState(true);


    const handleSubmitAddInventory = async () => {
        setIsAddInventoryFormDisabled(true);
        const finalAddInventoryForm = JSON.parse(JSON.stringify(addInventoryForm));
        finalAddInventoryForm.quantity = parseInt(finalAddInventoryForm.quantity);
        finalAddInventoryForm.issuedQuantity = parseInt(finalAddInventoryForm.issuedQuantity);
        finalAddInventoryForm.reorderPoint = parseInt(finalAddInventoryForm.reorderPoint);
        try {
        const response = await apiClient.post(`/b-inventory`,Object.fromEntries(Object.entries(finalAddInventoryForm).filter(([_, v]) => v !== '')));
        if(response?.data) {
            navigate(`/ar/inventory`);
        } else {
            setIsAddInventoryFormDisabled(false);
        }
        } catch(err) {
            setIsAddInventoryFormDisabled(false);
            if(err?.response?.data?.errors) {
                let errorsList = {};
                err?.response?.data?.errors?.map(err=>{
                    errorsList[err.field] = err.message; 
                });
                setErrors(errorsList);
            }
        }
    }

    const hideError = (err) => {
      if(errors) {
        let errorsList = errors;
        delete errorsList[err];
        setErrors(errorsList);
      }
    }

    useEffect(()=>{
        if(addInventoryForm 
            && addInventoryForm?.itemName && addInventoryForm?.itemName !== ''
            && addInventoryForm?.itemCode && addInventoryForm?.itemCode !== ''
            && addInventoryForm?.category && addInventoryForm?.category !== ''
            && addInventoryForm?.storageLocation && addInventoryForm?.storageLocation !== ''
            && addInventoryForm?.quantity && addInventoryForm?.quantity !== ''
            && addInventoryForm?.issuedQuantity && addInventoryForm?.issuedQuantity !== ''
            && addInventoryForm?.reorderPoint && addInventoryForm?.reorderPoint !== ''
            && addInventoryForm?.supplierInfo && addInventoryForm?.supplierInfo !== '') {
            setIsAddInventoryFormDisabled(false);
        } else {
            setIsAddInventoryFormDisabled(true);
        }
    },[addInventoryForm])

    return (
        <div>
        <PageHeader pageTitle={pageTitle} />
        <PageMain>
            <span className="fixed top-0 left-0 right-0 bottom-0 z-[-1] bg-grey-50"></span>
            <MainContent>
                <NormalFormContainer heading="من فضلك قم بملئ البيانات التالية لإضافة مخزون جديد." label="أضف مخزون">
                    
                    <div className="mb-[15px]">
                        <InputField label={'الاسم'} placeholder={'اكتب اسم المخزون'} value={addInventoryForm?.itemName} error={errors?.itemName} errorMessage={errors?.itemName} translateError={true} onChange={(e)=>{setAddInventoryForm({ ...addInventoryForm, itemName: e.target.value }); hideError('itemName')}} />
                    </div>

                    <div className="mb-[15px]">
                        <InputField label={'الكود'} placeholder={'اكتب كود المخزون'} value={addInventoryForm?.itemCode} error={errors?.itemCode} errorMessage={errors?.itemCode} translateError={true} onChange={(e)=>{ setAddInventoryForm({ ...addInventoryForm, itemCode: e.target.value }); hideError('itemCode')}} />
                    </div>

                    <div className="mb-[15px]">
                        <MultiSelect label={'الفئة'} placeholder={'اختر فئة المخزون'} options={InventoryCategoriesOptions} error={errors?.category} errorMessage={errors?.category} value={addInventoryForm?.category && InventoryCategoriesOptions[InventoryCategoriesOptions.findIndex(option => option?.value === addInventoryForm?.category)]} onChange={(option)=>{setAddInventoryForm({ ...addInventoryForm, category: option?.value }); hideError('category')}} />
                    </div>

                    <div className="mb-[15px]">
                        <InputField label={'مكان التخزين'} placeholder={'اكتب مكان التخزين'} value={addInventoryForm?.storageLocation} error={errors?.storageLocation} errorMessage={errors?.storageLocation} translateError={true} onChange={(e)=>{ setAddInventoryForm({ ...addInventoryForm, storageLocation: e.target.value }); hideError('storageLocation')}} />
                    </div>

                    <div className="mb-[15px]">
                        <InputField label={'الكمية الكلية'} placeholder={'اكتب الكمية الكلية'} value={addInventoryForm?.quantity} error={errors?.quantity} errorMessage={errors?.quantity} translateError={true} onChange={(e)=>{  if(e.target.value === '' || e.target.value === '0' || /^\d*[1-9]\d*$/.test(e.target.value)) { setAddInventoryForm({ ...addInventoryForm, quantity: e.target.value }) }; hideError('quantity')}} />
                    </div>

                    <div className="mb-[15px]">
                        <InputField label={'الكمية المستخدمة'} placeholder={'اكتب الكمية المستخدمة'} value={addInventoryForm?.issuedQuantity} error={errors?.issuedQuantity} errorMessage={errors?.issuedQuantity} translateError={true} onChange={(e)=>{  if(e.target.value === '' || e.target.value === '0' || /^\d*[1-9]\d*$/.test(e.target.value)) { setAddInventoryForm({ ...addInventoryForm, issuedQuantity: e.target.value }) }; hideError('issuedQuantity')}} />
                    </div>

                    <div className="mb-[15px]">
                        <InputField label={'أقل عدد مخزون لإعادة الطلب'} placeholder={'اكتب عدد أقل عدد مخزون لإعادة الطلب'} value={addInventoryForm?.reorderPoint} error={errors?.reorderPoint} errorMessage={errors?.reorderPoint} translateError={true} onChange={(e)=>{ if(e.target.value === '' || e.target.value === '0' || /^\d*[1-9]\d*$/.test(e.target.value)) { setAddInventoryForm({ ...addInventoryForm, reorderPoint: e.target.value }) }; hideError('reorderPoint')}} />
                    </div>

                    <div className="mb-[15px]">
                        <InputField label={'معلومات المورد'} placeholder={'اكتب معلومات المورد'} value={addInventoryForm?.supplierInfo} error={errors?.supplierInfo} errorMessage={errors?.supplierInfo} translateError={true} onChange={(e)=>{setAddInventoryForm({ ...addInventoryForm, supplierInfo: e.target.value }); hideError('supplierInfo')}} />
                    </div>

                    <div className="text-end">
                        <NormalButton label={'إضافة المخزون'} onClick={handleSubmitAddInventory} isDisabled={isAddInventoryFormDisabled} />
                    </div>

                </NormalFormContainer>
                <br />
            </MainContent>
        </PageMain>
        </div>
    )

}

export default InventoryAddPage;